export const MOBILE_OPERATE_WIDTH = 768;
export const MEP_SENEBI_THRESHOLD = 5000;

export const operateSectionMobileTabs = [
  {
    label: "Comprar",
    value: "BUY",
  },
  {
    label: "Vender",
    value: "SELL",
  },
];
